import { Component, EventEmitter, ChangeDetectorRef, HostListener, OnDestroy, OnInit, Output, ViewEncapsulation, signal } from '@angular/core'
import { UserInputService } from 'src/app/common/api/services/user-input.service'
import { Router } from '@angular/router'
import { ProgressiveProfileService } from 'src/app/common/api/services/progressive-profile.service'
import { WIRService } from 'src/app/common/api/services/wir.service'
import { ViewportScroller, KeyValuePipe } from '@angular/common'

import { GtmImplementation } from 'src/app/common/api/services/gtmImplementation'
import { reviewDetailsContent } from '../../../common/json/review-details-content'
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-review-details',
    templateUrl: './review-details.component.html',
    styleUrls: ['./review-details.component.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatCheckbox, KeyValuePipe]
})
export class ReviewDetailsComponent implements OnInit, OnDestroy {
  officeDetails: any
  selectedLanguage: any
  showLoader = signal(false)
  questions: any
  country: any
  officeId: any
  phoneNumber: any
  countryCode: any
  interestedIdpService: any
  interestedIdpServiceGTM: any
  dialcode: any
  marketingAcceptanceIndicator: boolean = false
  submitted: boolean = false
  personalDetailsText: any
  academicDetailsText: any
  englishProficiencyDetailsText: any
  otherTestNameText: any
  backText: any
  submitText: any

  allData: { [key: string]: any } = {}
  @Output() backClicked = new EventEmitter<void>()
  @Output() navigateToStep = new EventEmitter<number>()

  constructor (private userInputService: UserInputService,
    public wirService: WIRService,
    public route: Router,
    public ProgressiveProfileQuestionsService: ProgressiveProfileService,
    public viewPortScroller: ViewportScroller,
    public gtmImplementation: GtmImplementation,
    private cdr: ChangeDetectorRef
  ) {}

  showScrollBtnRev: boolean = false
  isScrollingRev: boolean = false
  private scrollTimer: any = null
 
  @HostListener('window:scroll')
  onWindowScroll (): void {
    this.showScrollBtnRev = window.scrollY > 50
    this.isScrollingRev = true
    this.cdr.detectChanges()
    clearTimeout(this.scrollTimer)
    this.scrollTimer = setTimeout(() => { 
      this.isScrollingRev = false 
      this.cdr.detectChanges()
    }, 300)
  }

  ngOnInit (): void {
    this.viewPortScroller.scrollToPosition([0, 0])
    this.gtmImplementation.pageView('review_details', 'signed_in_user', 'user_registration')
    this.officeDetails = JSON.parse(localStorage.getItem('sfResponse') || '{}')
    this.allData = this.userInputService.getAllValues()
    const dialCodeValue = this.userInputService.getValue('dialCode')?.option_label
    if (typeof dialCodeValue === 'string') {
      this.dialcode = dialCodeValue
    } else if (dialCodeValue && typeof dialCodeValue === 'object' && dialCodeValue.dialCode) {
      this.dialcode = dialCodeValue.dialCode
    } else {
      this.dialcode = dialCodeValue || ''
    }
    const mobileValue = this.userInputService.getValue('primary_mobile_number')
    const mobileNumber = typeof mobileValue === 'string' ? mobileValue : (mobileValue?.option_label || mobileValue?.option_value || '')
    this.phoneNumber = this.dialcode + ' ' + mobileNumber
    this.country = this.officeDetails?.wir_cognito_country
    this.countryCode = this.officeDetails?.wir_country_code
    if (this.userInputService.getValue('marketing_acceptance_flag')?.option_value !== undefined) {
      this.marketingAcceptanceIndicator = this.userInputService.getValue('marketing_acceptance_flag')?.option_value
    }
    if (this.userInputService.getValue('interestedIDPSerivce')) {
      const interestedData = this.allData['interestedIDPSerivce']

      this.interestedIdpService = Array.isArray(interestedData)
        ? interestedData
          .map((item: any) => item.option_value)
          .filter((val: string) => !!val)
          .join(',')
        : ''
    }
    this.selectedLanguage = localStorage.getItem('languageSelected') ? localStorage.getItem('languageSelected') : 'EN'
    this.getLanguageContent(this.selectedLanguage)
    this.getProgressiveProfileQstns()
  }

  getLanguageContent (language: any): any {
    if (language === 'EN') {
      this.personalDetailsText = reviewDetailsContent[language]?.personalDetails
      this.academicDetailsText = reviewDetailsContent[language]?.academicDetails
      this.englishProficiencyDetailsText = reviewDetailsContent[language]?.englishProficiencyDetails
      this.otherTestNameText = reviewDetailsContent[language]?.otherTestName
      this.backText = reviewDetailsContent[language]?.back
      this.submitText = reviewDetailsContent[language]?.submit
    } else {
      this.personalDetailsText = reviewDetailsContent[this.countryCode + '_' + language]?.personalDetails
      this.academicDetailsText = reviewDetailsContent[this.countryCode + '_' + language]?.academicDetails
      this.englishProficiencyDetailsText = reviewDetailsContent[this.countryCode + '_' + language]?.englishProficiencyDetails
      this.otherTestNameText = reviewDetailsContent[this.countryCode + '_' + language]?.otherTestName
      this.backText = reviewDetailsContent[this.countryCode + '_' + language]?.back
      this.submitText = reviewDetailsContent[this.countryCode + '_' + language]?.submit
    }
  }

  getProgressiveProfileQstns (): any {
    this.questions = this.ProgressiveProfileQuestionsService.serviceQuestions?.items[0]?.fields?.questions
    if (this.questions === undefined) {
      this.showLoader.set(true)
      this.ProgressiveProfileQuestionsService.getPPqstns().subscribe(
        (res: any) => {
          this.questions = res.items[0].fields.questions
          this.showLoader.set(false)
        },
        (error: any) => {
          console.log(error)
          this.showLoader.set(false)
          this.route?.navigateByUrl('/error')
        }
      )
    }
  }

  backButton (): void {
    this.gtmImplementation.trackEvents('wir_review_details', 'back_button', 'back', 'review_details', 'signed_in_user', 'user_registration')
    this.backClicked.emit()
  }

  getCheckboxValue (mappingField: string): boolean {
    if (mappingField.startsWith('marketing_acceptance_flag')) {
      return !!this.userInputService.getValue('marketing_acceptance_flag')?.option_value
    }
    return !!this.userInputService.getValue(mappingField)?.option_value
  }

  onCheckboxChange (mappingField: string, event: any): void {
    const checked = event.checked
    if (mappingField.startsWith('marketing_acceptance_flag')) {
      this.userInputService.setValue('marketing_acceptance_flag', checked)
      this.marketingAcceptanceIndicator = checked
    } else {
      this.userInputService.setValue(mappingField, { option_value: checked, option_label: checked })
    }
  }

  getConsentLabel (question: any): string {
    let label = question.label || ''

    // Handle labels with TERMS_LINK_HREF / PRIVACY_LINK_HREF placeholders
    if (label.includes('TERMS_LINK_HREF') || label.includes('PRIVACY_LINK_HREF')) {
      if (question.termsURL) {
        const termsURL = String(question.termsURL)
        label = label.replace(/TERMS_LINK_HREF\s*(.*?)\s*LINK_ATAG/g,
          `<a href="${termsURL}" target="_blank" rel="noopener noreferrer" class="consent-link" onclick="event.stopPropagation()">$1</a>`)
      }
      if (question.privacyURL) {
        const privacyURL = String(question.privacyURL)
        label = label.replace(/PRIVACY_LINK_HREF\s*(.*?)\s*LINK_ATAG/g,
          `<a href="${privacyURL}" target="_blank" rel="noopener noreferrer" class="consent-link" onclick="event.stopPropagation()">$1</a>`)
      }
    } else {
      // Handle plain text labels — inject links for "Terms" and "privacy policy"
      if (question.termsURL) {
        const termsURL = String(question.termsURL)
        label = label.replace(/(Terms)/i,
          `<a href="${termsURL}" target="_blank" rel="noopener noreferrer" class="consent-link" onclick="event.stopPropagation()">$1</a>`)
      }
      if (question.privacyURL) {
        const privacyURL = String(question.privacyURL)
        label = label.replace(/(privacy policy)/i,
          `<a href="${privacyURL}" target="_blank" rel="noopener noreferrer" class="consent-link" onclick="event.stopPropagation()">$1</a>`)
      }
    }
    return label
  }

  validateCheckboxes (): boolean {
    if (!this.questions) return true
    for (const q of this.questions) {
      if (q.displayFormat.value === 'CHECKBOX' && q.mandatory) {
        if (!this.getCheckboxValue(q.mappingField)) {
          return false
        }
      }
    }
    return true
  }

  getContactMeByValue (): string {
    const value = this.userInputService.getValue('contactMeBy')?.option_value
    return value ? 'Email, Phone' : ''
  }

  getMajorSubjectsValue (): any {
    const majorSubjects = this.userInputService.getValue('majorSubjects')
    if (Array.isArray(majorSubjects) && majorSubjects.length > 0) {
      return majorSubjects[0]?.option_value || null
    }
    return majorSubjects?.option_value || null
  }

  private getStringValue (value: any): string {
    if (!value) return ''
    if (typeof value === 'string') return value
    if (typeof value === 'object') {
      return value.option_value || value.option_label || ''
    }
    return ''
  }

  private getIdValue (value: any): string {
    if (!value) return ''
    if (typeof value === 'object') {
      return value.option_value || value.country_qual_id || value.qual_exam_board_id || value.grade_id || value.grade_value_id || ''
    }
    return typeof value === 'string' ? value : ''
  }

  private getNameValue (value: any): string {
    if (!value) return ''
    if (typeof value === 'object') {
      return value.option_desc || value.option_label || ''
    }
    return typeof value === 'string' ? value : ''
  }

  private formatDateToISOOrNull (dateStr: string | null): string | null {
    if (!dateStr) return null
    const parts = dateStr.split('/')
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`
    }
    return dateStr
  }

  isFirstApplicableGradeQuestion (question: any): boolean {
    const first = this.questions?.find((q: any) => q.mappingField === 'applicableGrade')
    return first === question
  }

  getBacklogsQuestionForReview (): any {
    return this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsOrRetakes')
  }

  getBacklogsLast2YearsQuestionForReview (): any {
    return this.questions?.find((q: any) => q.mappingField === 'numberOfBacklogsRetakesInLast2Years')
  }

  getUserInputValue (key: string): string | null {
    const value = this.userInputService.getValue(key)
    if (!value) return null
    if (typeof value === 'string') return value
    return value?.option_value || value?.option_label || null
  }

  private getStringOrNull (value: any): string | null {
    if (!value) return null
    if (typeof value === 'string') return value
    if (typeof value === 'object') {
      return value.option_value || value.option_label || null
    }
    return null
  }

  private getNumericOrNull (value: any): number | null {
    if (value === null || value === undefined) return null
    const numStr = typeof value === 'string' ? value : (value?.option_value || value?.option_label || '')
    const num = parseInt(numStr, 10)
    return isNaN(num) ? null : num
  }

  private getIdOrNull (value: any): string | null {
    if (!value) return null
    if (typeof value === 'object') {
      return value.option_value || value.country_qual_id || value.qual_exam_board_id || value.grade_id || value.grade_value_id || null
    }
    return typeof value === 'string' ? value : null
  }

  private getNameOrNull (value: any): string | null {
    if (!value) return null
    if (typeof value === 'object') {
      return value.option_label || null
    }
    return typeof value === 'string' ? value : null
  }

  private getInstitutionNameForPayload (): string | null {
    const institutionValue = this.userInputService.getValue('institutionName')
    const institutionLabel = this.getNameOrNull(institutionValue)
    if (institutionLabel?.toLowerCase() === 'others' || !institutionLabel) {
      const otherName = this.getStringOrNull(this.userInputService.getValue('other_institutionName'))
      if (otherName) return otherName
    }
    return institutionLabel
  }

  private getScoreValue (value: any): number | null {
    if (!value) return null
    const score = typeof value === 'string' ? value : (value?.option_value || value?.option_label)
    if (!score) return null
    const num = Number(score)
    return isNaN(num) ? null : num
  }

  private getIntOrNull (value: any): number | null {
    if (!value) return null
    const str = typeof value === 'string' ? value : (value?.option_value || value?.option_label)
    if (!str) return null
    const num = parseInt(str, 10)
    return isNaN(num) ? null : num
  }

  private getRoundedIntOrNull (value: any): number | null {
    if (!value) return null
    const str = typeof value === 'string' ? value : (value?.option_value || value?.option_label)
    if (!str) return null
    const num = Math.round(Number(str))
    return isNaN(num) ? null : num
  }

  private getCalculatedGrades (): any[] {
    const gradeTypeId = this.getGradeTypeId()
    const gradeType = this.getNameOrNull(this.userInputService.getValue('gradeType'))
    const grade = this.getNameOrNull(this.userInputService.getValue('finalGrade')) || this.getStringOrNull(this.userInputService.getValue('finalGrade'))
    if (gradeTypeId && gradeType && grade) {
      return [{ gradeTypeId, gradeType, grade }]
    }
    return []
  }

  private getIsHonoursDegreeValue (): boolean | null {
    const value = this.userInputService.getValue('isHonoursDegree')
    if (value === true) return true
    if (value === false) return false
    return null
  }

  private getApplicableGradeValue (): string | null {
    const value = this.userInputService.getValue('applicableGrade')
    if (!value) return null
    if (typeof value === 'string') return value
    return value?.option_label || value?.option_value || null
  }

  private getMajorSubjectIdsFormatted (): string | null {
    const majorSubjects = this.userInputService.getValue('majorSubjects')
    if (Array.isArray(majorSubjects) && majorSubjects.length > 0) {
      const ids = majorSubjects.map((item: any) => item.option_value).filter(Boolean)
      return ids.length > 0 ? JSON.stringify(ids).replace(/"/g, "'") : null
    }
    if (majorSubjects?.option_value) {
      return "['" + majorSubjects.option_value + "']"
    }
    return null
  }

  private getMajorSubjectsFormatted (): string | null {
    const majorSubjects = this.userInputService.getValue('majorSubjects')
    if (Array.isArray(majorSubjects) && majorSubjects.length > 0) {
      const labels = majorSubjects.map((item: any) => item.option_label).filter(Boolean)
      return labels.length > 0 ? JSON.stringify(labels).replace(/"/g, "'") : null
    }
    if (majorSubjects?.option_label) {
      return "['" + majorSubjects.option_label + "']"
    }
    return null
  }

  private getGradeTypeId (): string | null {
    const gradeType = this.userInputService.getValue('gradeType')
    if (!gradeType) return null
    return gradeType.grade_id || gradeType.option_value || null
  }

  private getFinalGradeRankForPayload (): number {
    const finalGrade = this.userInputService.getValue('finalGrade')
    if (!finalGrade || typeof finalGrade === 'string') return 0
    const rank = finalGrade.rank
    return (rank !== null && rank !== undefined) ? rank : 0
  }

  private getFinalGradeIdForPayload (): string | null {
    const finalGrade = this.userInputService.getValue('finalGrade')
    if (!finalGrade) return null
    if (typeof finalGrade === 'string') return null
    // For input-type grades, grade_value_id comes from the API response
    if (finalGrade.grade_value_id) return finalGrade.grade_value_id
    // For dropdown grades, option_value is the grade_value_id (unless it equals option_label, meaning user-entered text)
    if (finalGrade.option_value && finalGrade.option_label && finalGrade.option_value === finalGrade.option_label) {
      return null
    }
    return finalGrade.option_value || null
  }

  private getEducationIdForPayload (): string | null {
    const educationId = this.getStringOrNull(this.userInputService.getValue('educationId'))
    if (!educationId) return null
    const originalCountryCode = this.userInputService.getValue('cp_original_studyCountryCode')
    const originalQualTypeId = this.userInputService.getValue('cp_original_qualificationTypeId')
    const currentCountryCode = this.getIdOrNull(this.userInputService.getValue('studyCountryName'))
    const currentQualTypeId = this.getIdOrNull(this.userInputService.getValue('qualificationType'))
    if (originalCountryCode && currentCountryCode && originalCountryCode !== currentCountryCode) {
      return null
    }
    if (originalQualTypeId && currentQualTypeId && originalQualTypeId !== currentQualTypeId) {
      return null
    }
    return educationId
  }

  private getAdmissionTestIdForPayload (): string | null {
    const testId = this.getStringOrNull(this.userInputService.getValue('admissionTestId'))
    if (!testId) return null
    const originalTestTypeId = this.userInputService.getValue('cp_original_admissionTestTypeId')
    const currentTestTypeId = this.getIdOrNull(this.userInputService.getValue('academic_testType'))
    if (originalTestTypeId && currentTestTypeId && originalTestTypeId !== currentTestTypeId) {
      return null
    }
    return testId
  }

  private getEnglishTestIdForPayload (): string | null {
    const testId = this.getStringOrNull(this.userInputService.getValue('englishTestId'))
    if (!testId) return null
    const originalTestTypeId = this.userInputService.getValue('cp_original_englishTestTypeId')
    const currentTestTypeId = this.getIdOrNull(this.userInputService.getValue('english_testType'))
    if (originalTestTypeId && currentTestTypeId && originalTestTypeId !== currentTestTypeId) {
      return null
    }
    return testId
  }

  private buildAdmissionDetails (): any {
    const testTypeRaw = this.userInputService.getValue('academic_testType')
    const testTypeId = this.getIdOrNull(testTypeRaw)
    const testType = this.getNameOrNull(testTypeRaw)
    const isNotTaken = testTypeRaw?.option_value === 'tt_17' || (testTypeRaw?.option_desc || testType)?.toLowerCase() === 'not taken'
    const status = isNotTaken ? null : 'Taken'
    if (!testTypeId && !testType) {
      return {}
    }
    return {
      testId: this.getAdmissionTestIdForPayload(),
      testTypeId,
      testType,
      status,
      testTakenDate: isNotTaken ? null : this.formatDateToISOOrNull(this.getStringOrNull(this.userInputService.getValue('academic_testTakenDate'))),
      overallScore: isNotTaken ? null : this.getScoreValue(this.userInputService.getValue('academic_overallScore'))
    }
  }

  private buildEnglishTestDetails (): any {
    const englishIsFirst = this.getStringOrNull(this.userInputService.getValue('englishIsFirstLanguage'))
    const isExistingUser = localStorage.getItem('isExistingUser') === 'true'
    const englishTestTypeRaw = this.userInputService.getValue('english_testType')
    const testTypeId = this.getIdOrNull(englishTestTypeRaw)
    const testTypeLabel = this.getNameOrNull(englishTestTypeRaw)
    const isNotTaken = englishTestTypeRaw?.option_value === 'tt_16' || (englishTestTypeRaw?.option_desc || testTypeLabel)?.toLowerCase() === 'not taken'
    const testType = testTypeLabel?.toLowerCase() === 'others'
      ? this.getStringOrNull(this.userInputService.getValue('other_english_testType'))
      : testTypeLabel
    const status = isNotTaken ? null : 'Taken'

    // For existing users who chose "Yes" but have existing test data from CP, still pass the data
    if (englishIsFirst?.toLowerCase() === 'yes' && !isExistingUser) {
      return {}
    }
    if (englishIsFirst?.toLowerCase() === 'yes' && isExistingUser && !testTypeId && !testType) {
      return {}
    }

    if (!testTypeId && !testType) {
      return {}
    }
    return {
      testId: this.getEnglishTestIdForPayload(),
      testTypeId,
      testType,
      status,
      testTakenDate: isNotTaken ? null : this.formatDateToISOOrNull(this.getStringOrNull(this.userInputService.getValue('english_testTakenDate'))),
      overallScore: isNotTaken ? null : this.getScoreValue(this.userInputService.getValue('english_overallScore'))
    }
  }

  private getInterestedInLabels (): string {
    const interestedData = this.allData['interestedIDPSerivce']
    if (!Array.isArray(interestedData)) return ''
    return interestedData
      .map((item: any) => item.option_desc || item.option_label)
      .filter((val: string) => !!val)
      .join(',')
  }

  isEnglishTestTypeOthers (): boolean {
    const testType = this.allData['english_testType']
    if (!testType) return false
    const testTypeLabel = typeof testType === 'string' ? testType : (testType?.option_label || testType?.option_value)
    return typeof testTypeLabel === 'string' && testTypeLabel.toLowerCase() === 'others'
  }

  submitRegistrationForm (): any {
    this.submitted = true
    if (!this.validateCheckboxes()) return
    this.gtmImplementation.trackOptional('review_details', 'signed_in_user', 'user_registration')
    this.gtmImplementation.trackKPI('wir_user_registration_submit', 'submit', 'submit_button', 'user_registration', 'review_details', 'signed_in_user')
    this.showLoader.set(true)

    // Re-read office details to ensure mandatory fields are available
    if (!this.country || !this.countryCode || !this.officeDetails?.wir_counsellor_team) {
      const sfResponse = localStorage.getItem('sfResponse')
      if (sfResponse) {
        try {
          this.officeDetails = JSON.parse(sfResponse)
          this.country = this.officeDetails?.wir_cognito_country || this.country
          this.countryCode = this.officeDetails?.wir_country_code || this.countryCode
        } catch { /* keep existing values */ }
      }
    }

    const payload = {
      customerUuid: this.getStringValue(this.userInputService.getValue('customerUuid')),
      personal_details: {
        customerUuid: this.getStringValue(this.userInputService.getValue('customerUuid')),
        firstName: this.getStringValue(this.userInputService.getValue('first_name')),
        lastName: this.getStringValue(this.userInputService.getValue('last_name')),
        studentEmail: this.getStringValue(this.userInputService.getValue('primary_email')),
        mobileNumber: this.getStringValue(this.userInputService.getValue('primary_mobile_number')),
        phoneNumber: this.getStringValue(this.userInputService.getValue('primary_mobile_number')),
        dialCode: this.dialcode || '',
        gender: this.getNameValue(this.userInputService.getValue('gender')),
        genderCode: this.getIdValue(this.userInputService.getValue('gender')),
        dateOfBirth: this.getStringValue(this.userInputService.getValue('date_of_birth_API')),
        maritalStatus: this.getNameValue(this.userInputService.getValue('maritalStatus')),
        maritalStatusCode: this.getIdValue(this.userInputService.getValue('maritalStatus')),
        passport: this.getIdValue(this.userInputService.getValue('passport')),
        nationalityCode: this.getStringValue(this.userInputService.getValue('nationalityCode')),
        preferredStudyDestination: this.getStringValue(this.userInputService.getValue('preferredCountryCode')),
        interestedIn: this.getInterestedInLabels(),
        interestedInCode: this.interestedIdpService,
        marketingAcceptanceIndicator: this.marketingAcceptanceIndicator,
        preferredStudyLevel: this.getStringValue(this.userInputService.getValue('preferredStudyLevel')),
        plannedStudyDate: this.getStringValue(this.userInputService.getValue('studyPlanTimeline')),
        primaryFinancialSource: this.getNameValue(this.userInputService.getValue('primaryFinancialSource')),
        primaryFinancialSourceCode: this.getIdValue(this.userInputService.getValue('primaryFinancialSource')),
        howDidYouHear: this.getNameValue(this.userInputService.getValue('howDidYouHear')),
        howDidYouHearCode: this.getIdValue(this.userInputService.getValue('howDidYouHear')),
        englishIsFirstLanguage: this.getStringValue(this.userInputService.getValue('englishIsFirstLanguage')),
        preferred_counselling_mode: localStorage.getItem('counsellingMode') || 'In-Person',
        contactMeBy: this.getContactMeByValue(),
        siteIDCountry: this.country || this.officeDetails?.wir_cognito_country || '',
        countryCode: this.countryCode || this.officeDetails?.wir_country_code || '',
        siteCountryCode: this.countryCode || this.officeDetails?.wir_country_code || '',
        leadRoutingTeamID: this.officeDetails?.wir_counsellor_team || '',
        counsellorEmail: this.officeDetails?.counsellor_email || ''
      },
      academic_details: {
        educationId: this.getEducationIdForPayload(),
        institutionId: this.getIdOrNull(this.userInputService.getValue('institutionName')),
        institutionName: this.getInstitutionNameForPayload(),
        examBoardId: this.getIdOrNull(this.userInputService.getValue('examBoardName')),
        examBoardName: this.getNameOrNull(this.userInputService.getValue('examBoardName')),
        studyLanguageCode: this.getIdOrNull(this.userInputService.getValue('studyLanguageName')),
        studyLanguageName: this.getNameOrNull(this.userInputService.getValue('studyLanguageName')),
        studyStartDate: this.formatDateToISOOrNull(this.getStringOrNull(this.userInputService.getValue('studyStartDate'))),
        studyEndDate: this.formatDateToISOOrNull(this.getStringOrNull(this.userInputService.getValue('studyEndDate'))),
        gradeTypeId: this.getGradeTypeId(),
        gradeType: this.getNameOrNull(this.userInputService.getValue('gradeType')),
        finalGrade: this.getNameOrNull(this.userInputService.getValue('finalGrade')) || this.getStringOrNull(this.userInputService.getValue('finalGrade')),
        finalGradeId: this.getFinalGradeIdForPayload(),
        rank: this.getFinalGradeRankForPayload(),
        calculatedGrades: this.getCalculatedGrades(),
        isHonoursDegree: this.getIsHonoursDegreeValue(),
        institutionOverallPassGrade: this.getApplicableGradeValue(),
        failedSubjectsCount: this.getNumericOrNull(this.userInputService.getValue('numberOfBacklogsOrRetakes')),
        failedSubjectsLast2YearCount: this.getNumericOrNull(this.userInputService.getValue('numberOfBacklogsRetakesInLast2Years')),
        qualificationTypeId: this.getIdOrNull(this.userInputService.getValue('qualificationType')),
        qualificationType: this.getNameOrNull(this.userInputService.getValue('qualificationType')),
        qualificationTitle: this.getStringOrNull(this.userInputService.getValue('qualificationTitle')),
        majorSubjectIds: this.getMajorSubjectIdsFormatted(),
        majorSubjects: this.getMajorSubjectsFormatted(),
        studyMode: this.getStringOrNull(this.userInputService.getValue('studyMode')),
        studyStatus: this.getStringOrNull(this.userInputService.getValue('studyStatus')),
        studyCountryCode: this.getIdOrNull(this.userInputService.getValue('studyCountryName')),
        studyCountryName: this.getNameOrNull(this.userInputService.getValue('studyCountryName')),
        studyDuration: this.getRoundedIntOrNull(this.userInputService.getValue('studyDuration'))
      },
      admission_details: this.buildAdmissionDetails(),
      english_test_details: this.buildEnglishTestDetails()
    }
    this.wirService.userRegistrationForm(payload).subscribe((data: any) => {
      this.showLoader.set(false)
      this.route?.navigateByUrl('/thankyou')
    }, (error: any) => {
      console.log(error.error.message)
      this.showLoader.set(false)
      if (error.error.message === 'Invalid request body') {
        localStorage.setItem('detailsPage', 'true')
      }
      this.route?.navigateByUrl('/error')
    })
  }

  scrollToTop (): void {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
 
  ngOnDestroy (): void {
    clearTimeout(this.scrollTimer)
  }
}
